import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface FieldTooltipProps {
  content: string;
  className?: string;
}

/**
 * A tooltip component designed to be used inside FormLabel components.
 * Displays an info icon that shows helpful context when hovered.
 */
export function FieldTooltip({ content, className }: FieldTooltipProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Info className={cn("h-3 w-3 text-muted-foreground cursor-help ml-1 inline align-baseline", className)} />
        </TooltipTrigger>
        <TooltipContent>
          <p>{content}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
